import { ENV } from "../utils";

export class Location {
  baseApi = ENV.BASE_API;

  async getLocations(accessToken, active = true) {
    const url = `${this.baseApi}/locations?active=${active}`;
    const response = await fetch(url, { headers: { Authorization: `Bearer ${accessToken}` } });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createLocation(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-location`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateLocation(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-location/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteLocation(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-location/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
